import {
  handleFirstCharacterOfSentence,
  IDeliveryInformationMobile,
  IOwningIndividual,
} from '@vfit/consumer/data-access';
import { IAddressDataObject, IEditAddressConfig } from '@vfit/shared/models';

export const getDataOrganized = (
  deliveryData: IDeliveryInformationMobile,
  owningIndividual: IOwningIndividual,
  billingAddress: IAddressDataObject,
  shippingAddress: IAddressDataObject,
  editAddressConfig: IEditAddressConfig,
  isEsim?: boolean,
  isEsimFD?: boolean,
  isCourier?: boolean
) => {
  const simInformation = deliveryData?.deliveryinformationm?.selfService?.sim;
  const esimInformation = deliveryData?.deliveryinformationm?.selfService?.eSim;
  const esimFullyDigitalInformation =
    deliveryData?.deliveryinformationm?.selfService?.eSimFullyDigital;
  const courierInformation = deliveryData?.deliveryinformationm?.courrier;

  let topInformation: { topTitle: string; description?: string } = {
    topTitle: '',
    description: '',
  };
  if (isEsim) {
    if (!isEsimFD) {
      topInformation = {
        ...topInformation,
        topTitle: esimInformation?.title || '',
        description:
          esimInformation?.description || '',
      };
    } else {
      topInformation = {
        ...topInformation,
        topTitle:
          esimFullyDigitalInformation?.title || esimInformation?.title || '',
        description:
          esimFullyDigitalInformation?.description ||
          esimInformation?.description || '',
      };
    }
  } else if (isCourier) {
    topInformation = {
      ...topInformation,
      topTitle: courierInformation?.title || simInformation?.title || '',
      description:
        courierInformation?.description ||
        simInformation?.description || '',
    };
  } else {
    topInformation = {
      ...topInformation,
      topTitle: simInformation?.title || '',
      description:
        simInformation?.description || '',
    };
  }

  return {
    ...topInformation,
    userInfoTitle: '',
    userData: {
      lastName: owningIndividual?.lastName,
      firstName: owningIndividual?.firstName,
      address: handleFirstCharacterOfSentence(shippingAddress?.street || '').concat(
        ' ',
        shippingAddress?.streetNumber || ''
      ),
      city: handleFirstCharacterOfSentence(shippingAddress?.city || ''),
      zipCode: shippingAddress?.postalCode || '',
      province: shippingAddress?.stateOrProvince || '',
    },
    billingData: {
      title:
        deliveryData?.deliveryinformationm?.addressBilling?.bottomTitle || '',
      matchAddress:
        deliveryData?.deliveryinformationm?.addressBilling?.title || '',
      noMatch:
        deliveryData?.deliveryinformationm?.addressBilling?.description || '',
      labelEdit:
        deliveryData?.deliveryinformationm?.addressBilling?.linkLabelEdit || '',
      changeAddress:
        deliveryData?.deliveryinformationm?.addressBilling?.linkLabel || '',
      addressData: {
        lastName: owningIndividual?.lastName || '',
        firstName: owningIndividual?.firstName || '',
        address: handleFirstCharacterOfSentence(billingAddress?.street).concat(
          ' ',
          billingAddress?.streetNumber || ''
        ),
        city: handleFirstCharacterOfSentence(billingAddress?.city),
        zipCode: billingAddress?.postalCode || '',
        province: billingAddress?.stateOrProvince || '',
      },
    },
    shippingData: {
      title:
        deliveryData?.deliveryinformationm?.addressShipping?.title || '',
      matchAddress:
        deliveryData?.deliveryinformationm?.addressShipping?.subtitle || '',
      noMatch: deliveryData?.deliveryinformationm?.addressShipping?.address || '',
      labelEdit:
        deliveryData?.deliveryinformationm?.addressShipping?.linkLabelEdit || '',
      changeAddress:
        deliveryData?.deliveryinformationm?.addressShipping?.linkLabel || '',
      addressData: {
        lastName: owningIndividual?.lastName || '',
        firstName: owningIndividual?.firstName || '',
        address: handleFirstCharacterOfSentence(shippingAddress?.street || '').concat(
          ' ',
          shippingAddress?.streetNumber || ''
        ),
        city: handleFirstCharacterOfSentence(shippingAddress?.city),
        zipCode: shippingAddress?.postalCode || '',
        province: shippingAddress?.stateOrProvince || '',
        note: shippingAddress?.note || '',
        postalOfficeDescription: shippingAddress?.postalOfficeDescription || '',
      },
    },
    billingDataEsim: {
      title:
        deliveryData?.deliveryinformationm?.addressBillingEsim?.bottomTitle || '',
      matchAddress:
        deliveryData?.deliveryinformationm?.addressBillingEsim?.title || '',
      noMatch:
        deliveryData?.deliveryinformationm?.addressBillingEsim?.description || '',
      labelEdit:
        deliveryData?.deliveryinformationm?.addressBillingEsim?.linkLabelEdit || '',
      changeAddress:
        deliveryData?.deliveryinformationm?.addressBillingEsim?.linkLabel || '',
      addressData: {
        lastName: owningIndividual?.lastName || '',
        firstName: owningIndividual?.firstName || '',
        address: handleFirstCharacterOfSentence(billingAddress?.street).concat(
          ' ',
          billingAddress?.streetNumber || ''
        ),
        city: handleFirstCharacterOfSentence(billingAddress?.city),
        zipCode: billingAddress?.postalCode || '',
        province: billingAddress?.stateOrProvince || '',
      },
    },
    shippingDataEsim: {
      title:
        deliveryData?.deliveryinformationm?.addressShippingEsim?.title || '',
      matchAddress:
        deliveryData?.deliveryinformationm?.addressShippingEsim?.subtitle || '',
      noMatch:
        deliveryData?.deliveryinformationm?.addressShippingEsim?.address || '',
      labelEdit:
        deliveryData?.deliveryinformationm?.addressShippingEsim?.linkLabelEdit || '',
      changeAddress:
        deliveryData?.deliveryinformationm?.addressShippingEsim?.linkLabel || '',
      addressData: {
        lastName: owningIndividual?.lastName || '',
        firstName: owningIndividual?.firstName || '',
        address: handleFirstCharacterOfSentence(shippingAddress?.street || '').concat(
          ' ',
          shippingAddress?.streetNumber || ''
        ),
        city: handleFirstCharacterOfSentence(shippingAddress?.city),
        zipCode: shippingAddress?.postalCode || '',
        province: shippingAddress?.stateOrProvince || '',
        note: shippingAddress?.note || '',
        postalOfficeDescription: shippingAddress?.postalOfficeDescription || '',
      },
    },
    deliveryCta: '',
    afterEditAddress: '',
    editAddressConfig,
    noteLabels: {
      noteTitle:
        deliveryData?.deliveryinformationm?.commonLabel?.descriptionNote || '',
      noteTitleAfterEdit:
        deliveryData?.deliveryinformationm?.commonLabel?.linkLabelEdit || '',
    },
    noteModalConfig: {
      title: deliveryData?.deliveryinformationm?.commonLabel?.linkLabel || '',
      description:
        deliveryData?.deliveryinformationm?.commonLabel?.modalTextLabel || '',
      textLabel:
        deliveryData?.deliveryinformationm?.commonLabel?.placeholderNotes || '',
      ctaLabel: deliveryData?.deliveryinformationm?.commonLabel?.modalCtaLabel || '',
      titleMod:
        deliveryData?.deliveryinformationm?.commonLabel?.linkLabelEdit || '',
      descriptionMod:
        deliveryData?.deliveryinformationm?.commonLabel?.linkLabel || '',
    },
    disableAddNotes: deliveryData?.deliveryinformationm?.disableAddNotes === 'true',
  };
};

